import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import MtdCost from 'app/containers/MainDashboard/panels/MtdCost.jsx';
import PreviousMonthCost from 'app/containers/MainDashboard/panels/PreviousMonthCost.jsx';
import AnnualSavings from 'app/containers/MainDashboard/panels/AnnualSavings.jsx';
import OpenRecommendations from 'app/containers/MainDashboard/panels/OpenRecommendations.jsx';
import ForecastedCost from 'app/containers/MainDashboard/panels/ForecastedCost.jsx';
import LinkedAccountTotal from 'app/containers/MainDashboard/panels/LinkedAccountTotal.jsx';
import { useRootStore } from 'app/contexts/RootStoreContext.jsx';
import CostGptPanel from 'app/containers/MainDashboard/panels/CostGptPanel.jsx';
import BudgetsData from 'app/containers/MainDashboard/panels/MonitoringData/BudgetsData.jsx';
import { useMainDashboardContext } from 'app/containers/MainDashboard/contexts/mainDashboardContext.jsx';
import { ACCOUNT_FEATURES, CLOUD_TYPE_IDS } from 'users/constants/usersConstants.js';
import mainStyles from '../mainDashboardCommon.module.scss';
import styles from './costPanelWrapper.module.scss';

const CostPanelsWrapper = ({ currentOverrideCurrency, accountKey, divisionId, userKey, isDashboardPanel = false }) => {
  const { usersStore, appStore } = useRootStore();
  const costPanelsWrapperRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState('100%');
  const { getOverrideAccount } = useMainDashboardContext();
  const isKeyCloakManagement = appStore.isKeyCloakManagement;
  const accountFeatures = usersStore.getCurrentDisplayedAccountFeatures(usersStore.currDispUserAccountKey);

  const withOverrideApiKey = {
    rootStore: { usersStore, appStore },
    accountKey,
    divisionId,
    userKey,
  };
  useEffect(() => {
    if (isDashboardPanel && costPanelsWrapperRef.current) {
      setMaxWidth(`${costPanelsWrapperRef.current.offsetWidth}px`);
    }
  }, [isDashboardPanel, costPanelsWrapperRef.current?.offsetWidth]);

  const isSingleAccount = !accountKey ? usersStore.isCurrentAccountSingle : usersStore.isAccountSingle(accountKey);
  const isMultiCloudAccount = !accountKey
    ? usersStore.isCurrentAccountMulticloud
    : getOverrideAccount(accountKey)?.cloudTypeId === CLOUD_TYPE_IDS.MULTI;
  const content = (
    <>
      <div className={styles.costWrapper}>
        <MtdCost withOverrideApiKey={withOverrideApiKey} currentOverrideCurrency={currentOverrideCurrency} />
        <PreviousMonthCost withOverrideApiKey={withOverrideApiKey} currentOverrideCurrency={currentOverrideCurrency} />
        <ForecastedCost withOverrideApiKey={withOverrideApiKey} currentOverrideCurrency={currentOverrideCurrency} />
        {isSingleAccount && (
          <AnnualSavings withOverrideApiKey={withOverrideApiKey} currentOverrideCurrency={currentOverrideCurrency} />
        )}
      </div>
      <div
        className={classNames(styles.dataPanelsWrapper, usersStore.isCurrentAccountAllAccounts && styles.smallWrapper)}
      >
        {isSingleAccount && <OpenRecommendations withOverrideApiKey={withOverrideApiKey} />}
        {isMultiCloudAccount && (
          <BudgetsData
            accountKey={accountKey}
            divisionId={divisionId}
            userKey={userKey}
            currentOverrideCurrency={currentOverrideCurrency}
            isCostPanel={true}
          />
        )}
        <LinkedAccountTotal withOverrideApiKey={withOverrideApiKey} isSingleAccount={isSingleAccount} />
        {!(isKeyCloakManagement && !(accountFeatures || []).includes(ACCOUNT_FEATURES.COST_GPT_NEW_UM)) && (
          <CostGptPanel />
        )}
      </div>
    </>
  );
  return (
    <div ref={costPanelsWrapperRef} className={classNames(styles.costPanelsWrapper, mainStyles.fullWidth)}>
      {isDashboardPanel ? (
        <div className={styles.scrollOnHover} style={{ maxWidth }}>
          {content}
        </div>
      ) : (
        content
      )}
    </div>
  );
};

export default CostPanelsWrapper;
